import React from 'react'

export function Footer() {
    return (
        <div className="flex h-full items-center justify-end bg-black pr-3 text-sm text-gray-400">
            <span>
                wwww.boikone-preview.com created by{' '}
                <a
                    href="https://twitter.com/sniper_voice/"
                    className="hover:underline"
                >
                    @sniper_voice
                </a>
            </span>
        </div>
    )
}
